module.exports = __webpack_public_path__ + "static/img/modal-coin-icon.b816bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/modal-coin-icon.png
// module id = lm0m
// module chunks = 216